/* eslint-disable no-template-curly-in-string */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-restricted-syntax */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import { ToolbarComponent, ItemsDirective, ItemDirective, AccordionComponent, AccordionItemDirective, AccordionItemsDirective } from '@syncfusion/ej2-react-navigations';
import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { Tooltip } from '@syncfusion/ej2-popups';
import { ButtonComponent, SwitchComponent, CheckBoxComponent, RadioButtonComponent } from '@syncfusion/ej2-react-buttons';
import React, { useState, useEffect, useRef } from 'react';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Sort,
  Filter,
  Resize,
  Edit,
  Toolbar,
  Page,
  PdfExport,
  ExcelExport,
  ForeignKey,
  LazyLoadGroup,
  VirtualScroll,
  Group,
  columnDataStateChange,
  rowSelected,
} from '@syncfusion/ej2-react-grids';
// import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Legend, Tooltip, DataLabel, Category, BarSeries, Selection } from '@syncfusion/ej2-react-charts';
import { TextBoxComponent, UploaderComponent } from '@syncfusion/ej2-react-inputs';

import { useSearchParams, useNavigate, Link } from 'react-router-dom';

import { DataManager, Query } from '@syncfusion/ej2-data';
import axios from 'axios';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import scribeHow from '../data/scribehow.png';
import { useStateContext } from '../contexts/ContextProvider';
import { GMap, BasicTabs, Events, DevLog, Heartbeat, Header, useWindowDimensions, UserFAQ } from '../components';
import orgpng from '../data/organization.png';
import lngpng from '../data/language.png';
import { associateGrid } from '../data/dummy';
import './Zackat.css';
import profile from '../data/profile.png';

const AssociatePage = () => {
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  const navigate = useNavigate();
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=associatescontrolcenter');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  /*
  let initialRow = [];
  const settings = { mode: 'Row', type: 'Multiple' };
  const selectRowByPrimaryKey = async () => {
    if (grid) {
      grid.selectRow(initialRow[0]);
    }
  };
  */
  const [enableDetails, setDetails] = useState(true);
  const [enableEvents, setEvents] = useState(true);
  const [inviteEnable, setInviteEnable] = useState(false);
  const [associateid, setAssociateId] = useState('');
  const [limit, setLimit] = useState(0);
  const [groupLazy, setGroupLazy] = useState(true);
  const [searchParams] = useSearchParams();
  const [crudUpdate, setCrudUpdate] = useState(false);
  const [crudCreate, setCrudCreate] = useState(false);
  const [crudDelete, setCrudDelete] = useState(false);
  const { amapActive,
    setAmapActive,
    setAccordionExpanded,
    boss,
    zRenderMode,
    isMobile,
    isClicked,
    handleClick,
    setAIType,
    setPatientId,
  } = useStateContext();

  const currentThemeColor = localStorage.getItem('colorMode');
  const [currentAssociate, setCurrentAssoicate] = useState(localStorage.getItem('currentAssociate'));
  // const selectionSettings = { mode: 'Row', type: 'Single' };
  // const details = { text: 'Location', tooltipText: 'Associate Location', prefixIcon: 'e-expand', id: 'location', disabled: enableDetails };
  // const events = { text: 'Events', tooltipText: 'Associate Events', prefixIcon: 'e-justify', id: 'events', disabled: enableEvents };
  // const alerts = { text: 'Alerts', tooltipText: 'Clear Alerts', prefixIcon: 'e-delete-2', id: 'alerts', disabled: enableEvents };
  const invite = { text: 'Invite', tooltipText: 'MobileApp Invitation', prefixIcon: 'e-callout', id: 'invite', visible: inviteEnable, disabled: enableDetails };
  const ai = { text: 'AI', tooltipText: 'Predictive Analysis', prefixIcon: 'e-assistview-icon', id: 'ai', visible: boss, disabled: enableDetails };
  // const add = { text: 'Add', tooltipText: 'Add Associate', prefixIcon: 'e-add', id: 'add', disabled: false };
  // const toolbarOptions = ['Search', 'Add', 'Edit', 'Delete', details, events, alerts, invite, 'PdfExport', 'ExcelExport'];
  const toolbarOptions = [invite, ai, 'PdfExport', 'ExcelExport', 'Search'];
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [colDisplay, setColDisplay] = useState(false);
  const [sortOptions, setSortColumns] = useState({});
  const [groups, setGroups] = useState([]);
  const [riskColor, setRiskColor] = useState('e-outline');
  const [envColor, setEnvColor] = useState('e-outline');
  const [hypoColor, setHypoColor] = useState('transparent');
  const [baseColor, setBaseColor] = useState('transparent');
  const [moderateColor, setModerateColor] = useState('transparent');
  const [elevatedColor, setElevatedColor] = useState('transparent');
  const [severeColor, setSevereColor] = useState('transparent');
  const [eventData, setEventData] = useState({});
  const [selName, setName] = useState(currentAssociate);
  const [selVitals, setVitals] = useState('');
  const [selDevice, setDevice] = useState('');
  const [selOrganization, setOrganization] = useState('');
  const [selUploadOrganization, setUploadOrganization] = useState('');
  const [selLanguage, setLanguage] = useState('');
  const [selEngineering, setEngineering] = useState(false);
  const [selEmployeeImage, setEmployeeImage] = useState('');
  const [selMobile, setMobile] = useState('');
  const [selEmail, setEmail] = useState('');
  const [selReportsTo, setReportsTo] = useState('');
  const [associate, setAssociate] = useState(null);
  const [selRisk, setRisk] = useState('');
  const [selEnvironment, setEnvironment] = useState('');
  const [selAddress, setAddress] = useState('');
  const [selAddress1, setAddress1] = useState('');
  const [selCity, setCity] = useState('');
  const [selState, setState] = useState('');
  const [selZip, setZip] = useState('');
  const [selDob, setDob] = useState('');
  const [selAge, setAge] = useState('');
  const [selLat, setLat] = useState('');
  const [selLng, setLng] = useState('');
  const [smsOptin, setSMSOptin] = useState(false);
  const [emailOptin, setEmailOptin] = useState('');
  const [gender, setGender] = useState('');
  const [selTemperature, setTemperature] = useState('');
  const [selTemperatureBaseline, setTemperatureBaseline] = useState('');
  const [selHeartrate, setHeartrate] = useState('');
  const [selHeartrateBaseline, setHeartrateBaseline] = useState('');
  const [selOxygen, setOxygen] = useState('');
  const [selOxygenBaseline, setOxygenBaseline] = useState('');
  const [dataChanged, setDataChanged] = useState(false);
  const multilineAttributes = {
    rows: 4, // Sets the initial visible number of lines to 4
  };
  const expandCharts = () => {
    setAccordionExpanded(true);
  };
  const floatFocus = (args) => {
    args.target.parentElement.classList.add('e-input-focus');
  };
  const floatBlur = (args) => {
    args.target.parentElement.classList.remove('e-input-focus');
  };
  const onIconClick = (args) => {
    args.persist();
    setTimeout(() => {
      args.target.classList.add('e-input-btn-ripple');
    }, 500);
  };
  const onIconUnClick = (args) => {
    args.target.classList.remove('e-input-btn-ripple');
  };

  let chartInstance;
  const primaryxAxis = { minimum: 0, maximum: 11, interval: 1, title: 'Risk' };
  const primaryyAxis = {
    title: 'Percentage',
    minimum: 0,
    maximum: 100,
    labelFormat: '{value}%',
  };
  const tooltip = {
    enable: true,
    fill: '#78DA89',
    border: {
      width: 2,
      color: '#383838',
    },
  };
  let grid;
  const created = () => {
    if (grid && document.getElementById(`${grid.element.id}_searchbar`)) {
      document.getElementById(`${grid.element.id}_searchbar`).addEventListener('keyup', (event) => {
        if (event && event.target && event.target.value) {
          grid.search(event.target.value);
        }
      });
    }
    // Access individual cell values using row["columnName"]
  };

  const searchThis = () => {
    const search = document.getElementById('associatesearch');
    if (search && search.value && search.value.length > 0) {
      setName(search.value);
      localStorage.setItem('currentAssociate', search.value);
      setCurrentAssoicate(search.value);
      setReload(!reload);
    }
  };
  const handleKeyDown = (e) => {
    // Check if the pressed key is "Enter"
    if (e.key === 'Enter') {
      // Prevent the default form submission behavior
      e.preventDefault();
      // Perform your search or submission logic here
      searchThis(e);
      // Optional: Clear the textbox after searching
      // setValue('');
    }
  };
  const addProfile = () => {
    const result = orgData.find(({ id }) => id === selOrganization);
    const newassociate = {};
    newassociate.organizationid = selOrganization;
    newassociate.organization = result.value;
    const lresult = langData.find(({ id }) => id === selLanguage);
    newassociate.language = lresult.id;
    newassociate.name = selName;
    newassociate.device = selDevice;
    newassociate.mobile = selMobile;
    newassociate.email = selEmail;
    newassociate.address = selAddress;
    newassociate.address1 = selAddress1;
    newassociate.city = selCity;
    newassociate.state = selState;
    newassociate.zip = selZip;
    if (selDob !== '') {
      newassociate.dob = new Date(selDob).toLocaleDateString();
    } else {
      newassociate.dob = '';
    }
    if (gender === 'male') {
      newassociate.gender = 'male';
    } else if (gender === 'female') {
      newassociate.gender = 'female';
    } else {
      newassociate.gender = '';
    }
    fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(newassociate),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        if (responseJson && responseJson._id) {
          newassociate._id = responseJson._id;
          setAssociateId(newassociate._id);
          setPatientId(newassociate._id);
        }
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert(responseJson.response);
        }
        setReload(!reload);
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during New Associate Insert!');
      });
  };
  const cancelProfile = () => {
    setAssociateId('');
    setOrganization('');
    setLanguage('');
  };
  const saveProfile = (e) => {
    e.preventDefault();
    if (selOrganization && associate.organizationid !== selOrganization) {
      const result = orgData.find(({ id }) => id === selOrganization);
      if (!confirm(`Would you like to move this Associate ${associate.name} from ${associate.organization} to ${result.value}`)) {
        return;
      }
      associate.organizationid = selOrganization;
      associate.organization = result.value;
    }
    if (selLanguage && associate.language !== selLanguage) {
      const result = langData.find(({ id }) => id === selLanguage);
      associate.language = result.id;
    }
    if (selName.length === 0) {
      DialogUtility.alert('Please provide a name for the associate');
      return;
    }
    if (selDevice.length > 0 && (selDevice.length < 19 || selDevice.length > 20)) {
      DialogUtility.alert('Please provide a valid device for the associate');
      return;
    }
    if (selEmail.length > 0 && !selEmail.includes('@') && !selEmail.includes('.')) {
      DialogUtility.alert('Please provide a valid email for the associate');
      return;
    }

    associate.name = selName;
    associate.device = selDevice;
    associate.mobile = selMobile;
    associate.email = selEmail;
    associate.address = selAddress;
    associate.address1 = selAddress1;
    associate.city = selCity;
    associate.state = selState;
    associate.zip = selZip;
    associate.engineering = selEngineering;
    if (selDob && selDob.length > 0 && selDob !== 'Invalid Date' && selDob !== 'undefined') {
      associate.dob = new Date(selDob).toLocaleDateString();
    } else {
      associate.dob = '';
    }
    if (gender === 'male') {
      associate.gender = 'male';
    } else if (gender === 'female') {
      associate.gender = 'female';
    }
    fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(associate),
    })
      .then((response) => response.json())
      .then(() => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        DialogUtility.alert('Profile saved');
        cancelProfile();
        if (grid) {
          grid.clearSelection();
          setAssociateId('');
          setPatientId('');
          setDetails(true);
        }
      })
      .catch((error) => {
        console.error(error);
        DialogUtility.alert('An error has occured during Update!');
      });
  };

  const onToolbarChange = (args) => {
    if (grid) {
      const selectedRow = grid.getSelectedRecords()[0];
      if (args.target.textContent === 'Update') {
        grid.endEdit();
      }
      if (args.target.textContent === 'Edit') {
        grid.startEdit();
      }
      if (args.target.textContent === 'Delete') {
        grid.deleteRecord(selectedRow);
      }
      if (args.target.textContent === 'Add') {
        grid.addRecord();
      }
      if (args.target.textContent === 'Raw Events') {
        navigate(`../events?id=${selectedRow._id}&name=${selectedRow.name}`);
      }
      if (args.target.textContent === 'Location' && selLat !== '' && selLng !== '') {
        navigate(`../basic?id=${selectedRow._id}&lat=${selLat}&lng=${selLng}&name=${selectedRow.name}&tabNo=1`);
      }
      if (args.target.textContent === 'PDF Export') {
        const properties = {
          fileName: `PDFExport_Associates_${new Date().toISOString()}.pdf`,
          pageOrientation: 'Landscape',
        };
        grid.pdfExport(properties);
      }
      if (args.target.textContent === 'Excel Export') {
        const properties = {
          fileName: `ExcelExport_Associates_${new Date().toISOString()}.xlsx`,
        };
        grid.excelExport(properties);
      }
    }
  };
  const [selectedOption, setSelectedOption] = useState('');
  const [actionData, setActionData] = useState([]);
  useEffect(() => {
    const myActionData = [
      { text: 'Not specified', value: 'na' },
      { text: 'FOTA', value: 'fota' },
      { text: 'Locate', value: 'locate' },
      { text: 'Reset', value: 'reset' },
      { text: 'SMS', value: 'sms' },
      { text: 'Rehome', value: 'rehome' },
    ];
    setActionData(myActionData);
    setSelectedOption('na');
  }, []);
  const actionComponent = () => (
    <div>
      <DropDownListComponent id="ddlelement" dataSource={actionData} placeholder="Device Action" default={selectedOption} onChange={smsDevice} />
    </div>
  );

  const audioData = [
    { text: 'Not specified', value: 'na' },
  ];
  const [selectedAudioOption, setSelectedAudioOption] = useState(audioData[0]);
  const audioComponent = () => (
    <div>
      <DropDownListComponent dataSource={audioData} placeholder="Send Recording" value={selectedAudioOption} onChange={recordingDevice} />
    </div>
  );
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (data.role && data.role.associates) {
      if (data.role.associates.permissions.includes('Create')) {
        setCrudCreate(true);
      }
      if (data.role.associates.permissions.includes('Update')) {
        setCrudUpdate(true);
      }
      if (data.role.associates.permissions.includes('Delete')) {
        setCrudDelete(true);
      }
      if (data.role.associates.permissions.includes('Invite')) {
        setInviteEnable(true);
      }
    }
  }, [data]);
  const biometricsComponent = () => (
    <div>
      <label htmlFor="showDisplay" style={{ padding: '10px 40px 10px 0' }}>
        Show Biometrics
      </label>
      <SwitchComponent id="showDisplay" checked={colDisplay} cssClass="bar-color handle-color" onChange={changeColDisplay} />
    </div>
  );
  const limitComponent = () => (
    <div style={{ float: 'right' }}>
      <label htmlFor="showLimit" style={{ padding: '10px 40px 10px 0' }}>
        Associate Limit
      </label>
      <input style={{ border: '2px solid black', backgroundColor: '#78DA89' }} type="text" defaultValue={limit} onChange={handleChangeLimit} />
    </div>
  );
  const inputStyle = { width: '400px', display: 'inline-block', float: 'right' };

  const searchComponent = () => (
    <div className="pt-2 relative mx-auto text-gray-600">
      <input
        className="border-2 border-gray-300 bg-white h-10 px-5 pr-16 rounded-lg text-sm focus:outline-none searchtext"
        type="search"
        name="search"
        style={inputStyle}
        id="associatesearch"
        defaultValue={currentAssociate}
        placeholder="Search, case sensitive name or device"
        onKeyDown={handleKeyDown}
      />
      <button type="button" className="absolute right-0 top-0 mt-5 mr-4" onClick={searchThis}>
        <svg
          className="text-gray-600 h-4 w-4 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 56.966 56.966"
          xmlSpace="preserve"
          width="512px"
          height="512px"
        >
          <path
            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
          />
        </svg>
      </button>
    </div>
  );
  const langData = [
    { value: 'English', id: 'en-US' },
    { value: 'German', id: 'de-DE' },
    { value: 'French', id: 'fr-FR' },
    { value: 'French (Canadian)', id: 'fr-CA' },
    { value: 'Spanish (US)', id: 'es-US' },
    { value: 'Spanish', id: 'es-ES' },
    { value: 'Portugese (Brazil)', id: 'pt-BR' },
    { value: 'Portugese (Portugal)', id: 'pt-PT' },
    { value: 'Danish', id: 'da-DK' },
    { value: 'Dutch', id: 'nl-NL' },
    { value: 'Austrailian', id: 'en-AU' },
    { value: 'English (British)', id: 'en-GB' },
    { value: 'English (India)', id: 'en-IN' },
    { value: 'English (Welsh)', id: 'en-GB-WLS' },
    { value: 'Icelandic', id: 'is-IS' },
    { value: 'Italian', id: 'it-IT' },
    { value: 'Japnense', id: 'ja-JP' },
    { value: 'Korean', id: 'ko-KR' },
    { value: 'Norweigan', id: 'nb-NO' },
    { value: 'Polish', id: 'pl-PL' },
    { value: 'Romanian', id: 'ro-RO' },
    { value: 'Russian', id: 'ru-RU' },
    { value: 'Swedish', id: 'sv-SE' },
    { value: 'Turkish', id: 'tr-TR' },
    { value: 'Welsh', id: 'cy-GB' },
    { value: 'Chinese (Simplified)', id: 'zh-CN' },
    { value: 'Chinese (Traditional)', id: 'zh-TW' },
  ];

  const [reload, setReload] = useState([]);
  const [hideDialog, setDialog] = useState(false);
  const handleDialogClick = () => {
    setDialog(!hideDialog);
  };
  const dialogClose = () => {
    setDialog(false);
  };
  const animationSettings = { effect: 'FlipYLeft' };
  const dbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  function setDateOfBirth(e) {
    setDob(e.value);
  }
  function rowDataBound(args) {
    /*
    if (args.row) {
      if (getValue('risk', args.data) > 80 || args.data.temperature.reading > 100) {
        args.row.classList.add('rowcellred');
      } else if (getValue('risk', args.data) > 50) {
        args.row.classList.add('rowcellylw');
      } else {
        args.row.classList.add('rowcellgrn');
      }
    }
    */
    args.row.selected = true;
  }
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.limit = 1;
    usr.associate = selName && selName.length > 0 ? selName : '***___***';
    if (currentAssociate && currentAssociate.length > 0) {
      usr.associate = currentAssociate;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/associates?abbrev=true&${query}`;
      setLoading(true);
      if (!usr.loggedIn) {
        navigate('/login');
        return;
      }
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      if (mydata && mydata.associates && mydata.user && mydata.user.preferences && mydata.user.preferences.associate) {
        if (mydata.user.preferences.associate.group) {
          const grp = mydata.user.preferences.associate.group;
          setGroups(grp);
        } else {
          setGroups(['organizationid']);
        }
        if (mydata.user.preferences.associate.biometrics) {
          const b = mydata.user.preferences.associate.biometrics;
          setColDisplay(b);
        }
        if (mydata.user.preferences.associate.sort && mydata.user.preferences.associate.sort[0].direction) {
          const mysortedColumns = { columns: mydata.user.preferences.associate.sort };
          setSortColumns(mysortedColumns);
        }
        if (mydata.user.preferences.associate) { // && mydata.user.preferences.associate.limit) {
          setLimit(mydata.user.preferences.associate.limit);
        }
      } else {
        if (currentAssociate && currentAssociate.length > 0) {
          DialogUtility.alert(`Associate not found ${currentAssociate}!`);
        }
        setGroups(['organizationid']);
      }
      setData(mydata);
      if (mydata && mydata._id && mydata._id.length > 0) {
        mydata.source = 'controlpanel';

        setAssociate(mydata);
        setAssociateId(mydata._id);
      } else {
        setAssociate(null);
        setAssociateId('');
        setPatientId('');
      }
      setLoading(false);
      // setTimeout(dataFetch, 30000);
    };
    dataFetch();
  }, [reload, limit]);

  useEffect(() => {
    const calculateAge = () => {
      if (selDob && selDob !== '') {
        const today = new Date();
        const birthDateObj = new Date(selDob);
        let calculatedAge = today.getFullYear() - birthDateObj.getFullYear();
        const monthDiff = today.getMonth() - birthDateObj.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
          calculatedAge -= 1;
        }
        setAge(calculatedAge);
      } else {
        setAge('');
      }
    };
    calculateAge();
  }, [selDob]);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.limit = limit;
    // fetch data
    const associateFetch = async () => {
      if (associateid !== '' && associateid !== 'add_associate') {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/associates?abbrev=true&${query}&associateid=${associateid}`;
        if (!usr.loggedIn) {
          navigate('/login');
          return;
        }
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json();
        if (mydata && mydata.associates && mydata.associates.length > 0) {
          setRisk(`${mydata.associates[0].risk ? mydata.associates[0].risk : ''}`);
          setEnvironment(`${mydata.associates[0].environment ? mydata.associates[0].environment : ''}`);
          setName(`${mydata.associates[0].name ? mydata.associates[0].name : ''}`);
          setDevice(`${mydata.associates[0].device ? mydata.associates[0].device : ''}`);
          setMobile(`${mydata.associates[0].mobile ? mydata.associates[0].mobile : ''}`);
          setEmail(`${mydata.associates[0].email ? mydata.associates[0].email : ''}`);
          setReportsTo(`${mydata.associates[0].reportsTo ? mydata.associates[0].reportsTo : ''}`);
          setAddress(mydata.associates[0].address ? mydata.associates[0].address : '');
          setAddress1(mydata.associates[0].address1 ? mydata.associates[0].address1 : '');
          setCity(mydata.associates[0].city ? mydata.associates[0].city : '');
          setState(mydata.associates[0].state ? mydata.associates[0].state : '');
          setZip(mydata.associates[0].zip ? mydata.associates[0].zip : '');
          setOrganization(mydata.associates[0].organizationid ? mydata.associates[0].organizationid : null);
          if (mydata.associates[0].employeeImage && mydata.associates[0].employeeImage.includes(mydata.associates[0]._id)) {
            const tm = new Date().getTime();
            setEmployeeImage(`${mydata.associates[0].employeeImage}&key=${tm}`);
          } else {
            setEmployeeImage('https://monaco.zackat.com/blank.png');
          }
          if (!mydata.associates[0].language) {
            setLanguage(null);
          } else {
            setLanguage(mydata.associates[0].language);
          }
          setEngineering(mydata.associates[0].engineering);

          if (mydata.associates[0].dob && mydata.associates[0].dob.length > 0 && mydata.associates[0].dob !== 'Invalid Date'
            && mydata.associates[0].dob !== 'undefined') {
            setDob(mydata.associates[0].dob ? mydata.associates[0].dob : '');
          } else {
            setAge('');
            setDob('');
          }
          setSMSOptin(mydata.associates[0].smsOptin);
          setEmailOptin(mydata.associates[0].emailOptin);
          if (mydata.associates[0].gender && (mydata.associates[0].gender.toLocaleLowerCase() === 'm' || mydata.associates[0].gender.toLocaleLowerCase() === 'male')) {
            setGender('male');
          } else if (mydata.associates[0].gender && (mydata.associates[0].gender.toLocaleLowerCase() === 'f' || mydata.associates[0].gender.toLocaleLowerCase() === 'female')) {
            setGender('female');
          } else {
            setGender('');
          }
          setTemperature(`${mydata.associates[0].temperature && mydata.associates[0].temperature.reading ? `${mydata.associates[0].temperature.reading} °F` : ''}`);
          setTemperatureBaseline(`${mydata.associates[0].baseline && mydata.associates[0].baseline.temperature && mydata.associates[0].baseline.temperature.nominal ? `${mydata.associates[0].baseline.temperature.nominal.toFixed(1)} °F` : ''}`);
          setHeartrate(`${mydata.associates[0].temperature && mydata.associates[0].heartrate.reading ? `${mydata.associates[0].heartrate.reading} bpm` : ''}`);
          setHeartrateBaseline(`${mydata.associates[0].baseline && mydata.associates[0].baseline.heartrate && mydata.associates[0].baseline.heartrate.nominal ? `${mydata.associates[0].baseline.heartrate.nominal.toFixed(1)} bpm` : ''}`);
          setOxygen(`${mydata.associates[0].temperature && mydata.associates[0].oxygen.reading ? `${mydata.associates[0].oxygen.reading}%` : ''}`);
          setOxygenBaseline(`${mydata.associates[0].baseline && mydata.associates[0].baseline.oxygen && mydata.associates[0].baseline.oxygen.nominal ? `${mydata.associates[0].baseline.oxygen.nominal.toFixed(1)}%` : ''}`);
          let vitals = '';
          if (mydata.associates[0].temperature && mydata.associates[0].temperature.reading) {
            vitals = `Temperature ${mydata.associates[0].temperature.reading} °F`;
            if (mydata.associates[0].baseline && mydata.associates[0].baseline.temperature && mydata.associates[0].baseline.temperature.nominal) {
              vitals += `\tBaseline ${mydata.associates[0].baseline.temperature.nominal.toFixed(1)} °F\r\n`;
            } else {
              vitals += '\tBaseline °F\r\n';
            }
          }
          if (mydata.associates[0].heartrate && mydata.associates[0].heartrate.reading) {
            vitals += `Heartrate ${mydata.associates[0].heartrate.reading} bpm`;
            if (mydata.associates[0].baseline && mydata.associates[0].baseline.heartrate && mydata.associates[0].baseline.heartrate.nominal) {
              vitals += `\tBaseline ${mydata.associates[0].baseline.heartrate.nominal.toFixed(1)} bpm\r\n`;
            } else {
              vitals += '\tBaseline bpm\r\n';
            }
          }
          if (mydata.associates[0].oxygen && mydata.associates[0].oxygen.reading) {
            vitals += `Oxygen ${mydata.associates[0].oxygen.reading} %`;
            if (mydata.associates[0].baseline && mydata.associates[0].baseline.oxygen && mydata.associates[0].baseline.oxygen.nominal) {
              vitals += `\tBaseline ${mydata.associates[0].baseline.oxygen.nominal.toFixed(1)} %\r\n`;
            } else {
              vitals += '\tBaseline %\r\n';
            }
          }
          if (mydata.associates[0].hydration && mydata.associates[0].hydration.reading) {
            vitals += `Hydration ${mydata.associates[0].hydration.reading} %`;
            if (mydata.associates[0].baseline && mydata.associates[0].baseline.hydration && mydata.associates[0].baseline.hydration.nominal) {
              vitals += `\tBaseline ${mydata.associates[0].baseline.hydration.nominal.toFixed(1)} %\r\n`;
            } else {
              vitals += '\tBaseline %\r\n';
            }
          }
          setVitals(vitals);
          mydata.associates[0].source = 'controlpanel';
          setAssociate(mydata.associates[0]);
          if (mydata.associates[0].latlng && mydata.associates[0].latlng.latitude !== 0 && mydata.associates[0].latlng.longitude !== 0) {
            setLat(mydata.associates[0].latlng.latitude.toString());
            setLng(mydata.associates[0].latlng.longitude.toString());
            setDetails(false);
          }
          if (mydata.associates[0].environment < 0) {
            setEnvColor('e-outline e-info');
          } else if (mydata.associates[0].environment === '' || mydata.associates[0].environment < 25) {
            setEnvColor('e-outline e-success');
          } else if (mydata.associates[0].environment < 50) {
            setEnvColor('e-outline e-info');
          } else if (mydata.associates[0].environment < 80) {
            setEnvColor('e-outline e-warning');
          } else if (mydata.associates[0].environment && mydata.associates[0].environment.length > 0) {
            setEnvColor('e-outline e-error');
          } else {
            setEnvColor('e-outline');
          }
          // setAssociateId(mydata.associates[0]._id);
          // setAssociate(mydata.associates[0]);
          setData(mydata);
        } else if (currentAssociate && currentAssociate.length > 0) {
          DialogUtility.alert(`Search Associate was not found ${currentAssociate}!`);
        }
        setLoading(false);
      }
    };
    associateFetch();
  }, [associateid]);

  const { height, width } = useWindowDimensions();
  const { activeMenu } = useStateContext();
  function formatPhoneNumber(phoneNumberString) {
    if (phoneNumberString.length <= 0) {
      return null;
    }
    if (phoneNumberString.length === 10) {
      phoneNumberString = `1${phoneNumberString}`;
    }
    const cleaned = (`${phoneNumberString}`).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  }
  const gridOrgHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={orgpng}
        alt="organization"
      />
      <pre>Organization</pre>
    </div>
  );

  const gridLangHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={lngpng}
        alt="language"
      />
      <pre>Language</pre>
    </div>
  );
  const groupOptions = {
    enableLazyLoading: groupLazy,
    columns: groups,
  };
  const {
    screenSize,
    setScreenSize,
  } = useStateContext();
  const [file, setFile] = useState();
  const orgData = [];
  const langParams = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(langData),
      fields: { value: 'id', text: 'value' },
      query: new Query(),
    },
  };
  const teamParams = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: new DataManager([
        { TeamDescr: 'Team 1', id: '1' },
        { TeamDescr: 'Team 2', id: '2' },
        { TeamDescr: 'Team 3', id: '3' },
      ]),
      fields: { text: 'TeamDescr', value: 'id' },
      query: new Query(),
    },
  };
  function handleChange(e) {
    e.preventDefault();
    const restore = associateid;
    let selected = null;
    if (grid) {
      selected = grid.getSelectedRowIndexes();
    }

    const filedata = new FormData();
    const imagedata = e.target.files[0];
    filedata.append('userfile', imagedata);
    if (associateid !== '' && associateid !== 'add_associate') {
      filedata.append('_id', associateid);
      filedata.append('fileName', e.target.files[0].name);
      setAssociateId('');
      setPatientId('');
    } else {
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/fileup`, {
      method: 'POST',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
      },
      body: filedata,
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // window.location.reload();
        // setReload(!reload);
        e.target.value = null;
        setTimeout(setAssociateId(e.target.id), 2000);
        setPatientId(e.target.id);
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during Insert!');
      });
  }
  function removePhoto(e) {
    let removeData = null;
    e.preventDefault();
    if (associate._id === e.target.id) {
      removeData = associate;
    }
    if (removeData == null || confirm(`Remove photo for ${associate.name}?`) === false) {
      return;
    }
    if (removeData !== null) {
      fetch(`${REACT_APP_API_ENDPOINT}/fileup`, {
        method: 'DELETE',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(removeData),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          setAssociateId('');
          setPatientId('');
          setReload(!reload);
        })
        .catch((error) => {
          DialogUtility.alert('An error has occured during Removal!');
        });
    }
  }
  const gridAssociateProfile = (props) => (
    <div className={`flex items-center gap-2 center 
      ${((props.activity && props.activity.alert && props.activity.alert.length > 0)
        || (props.heartrate && props.heartrate.alert && props.heartrate.alert.length > 0)
        || (props.bloodpressure && props.bloodpressure.alert && props.bloodpressure.length > 0)
        || (props.hydration && props.hydration.alert && props.hydration.alert.length > 0)
        || (props.temperature && props.temperature.alert && props.temperature.alert.length > 0)
        || (props.oxygen && props.oxygen.alert && props.oxygen.alert.length > 0)
        || (props.hrv && props.hrv.alert && props.hrv.alert.length > 0)) ? 'rowcellred' : 'rowcellgrn'}`}
    >
      {!props.employeeImage
        ? <input type="file" name="userfile" id={props._id} onChange={handleChange} />
        : (
          <div>
            <img
              className="rounded-full w-10 h-10"
              src={props.employeeImage ? props.employeeImage : profile}
              alt="employee"
            />
            <font color="black"><input type="submit" name="remove" id={props._id} value="&#x007F;" onClick={removePhoto} /></font>
            <br /><Link to={`tel:${props.mobile}`} style={{ textDecoration: 'underline !important' }}>{formatPhoneNumber(props.mobile)}</Link>{/* backgroundColor: 'white', color: '#78DA89', */}
          </div>
        )}
    </div>
  );
  const gridImageHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={profile}
      />
      <pre>Image</pre>
    </div>
  );
  let myScreenSize = 'auto';
  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
      setName(currentAssociate);
      setAssociateId('');
      setPatientId('');
      setAssociate(null);
      setEvents(true);
      setAmapActive(false);
    };
  }, []);
  useEffect(() => {
    const qid = searchParams.get('id');
    const name = searchParams.get('name');
    if (qid && qid.length > 0 && qid !== 'null') {
      if (name && name.length > 0) {
        // localStorage.setItem('currentAssociate', name);
        // setCurrentAssoicate(name);
        setName(name);
      }
      setAssociateId(qid);
      setPatientId(qid);
      setGroupLazy(false);
    }
    return () => {
      setAssociateId('');
      setGroupLazy(true);
    };
  }, []);
  const customiseCell = (args) => {
    if (args.column.field === 'risk') {
      let tflag = '';
      let oflag = '';
      let hflag = '';
      let bpflag = '';
      let hrflag = '';
      let hrvflag = '';
      if (args.data.temperature && args.data.temperature.alert && args.data.temperature.alert !== '') {
        tflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.heartrate && args.data.heartrate.alert && args.data.heartrate.alert !== '') {
        hrflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.bloodpressure && args.data.bloodpressure.alert && args.data.bloodpressure.alert !== '') {
        bpflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.oxygen && args.data.oxygen.alert && args.data.oxygen.alert !== '') {
        oflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.hydration && args.data.hydration.alert && args.data.hydration.alert !== '') {
        hflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.hrv && args.data.hrv.alert && args.data.hrv.alert !== '') {
        hrvflag = '<font color="red">&#10003;</font>';
      }
      // const temp = args.data.temperature.reading;
      // const hydration = args.data.hydration.reading;
      let set = false;
      let riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th bgcolor="cyan"><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
      if (args.data.risk < 0) {
        // args.cell.classList.add('riskbelow-30');
        args.cell.classList.add('rowcellblue');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th bgcolor="cyan"><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      } else if (args.data.risk === '' || args.data.risk < 25) {
        // args.cell.classList.add('riskbelow-30');
        args.cell.classList.add('rowcellgrn');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font><th><th  bgcolor="cyan"><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      } else if (args.data.risk < 50) {
        // args.cell.classList.add('riskbelow-80');
        args.cell.classList.add('rowcellylw');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font><th><th bgcolor="cyan"><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      } else if (args.data.risk < 80) {
        args.cell.classList.add('rowcellorn');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font><th><th bgcolor="cyan"><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      } else {
        // args.cell.classList.add('riskabove-80');
        args.cell.classList.add('rowcellred');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font><th><th bgcolor="cyan"><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      }
      // Universal AQI
      // Code: uaqi
      // Pollutants: "co", "no2", "o3", "pm10", "pm25", "so2"
      // 100 - 80 Excellent air quality
      // 79 - 60 Good air quality
      // 59 - 40 Moderate air quality
      // 39 - 20 Low air quality
      // 19 - 1 Poor air quality
      // 0 Poor air quality

      if (!set && args.data.environment < 20) {
        args.cell.classList.add('aqi20');
      } else if (!set && args.data.environment < 40) {
        args.cell.classList.add('aqi40');
      } else if (!set && args.data.environment < 60) {
        args.cell.classList.add('aqi60');
      } else if (!set && args.data.environment < 80) {
        args.cell.classList.add('aqi80');
      } else if (!set) {
        args.cell.classList.add('aqi100');
      }
      let bhrv = '';
      let bhr = '';
      let btemp = '';
      let boxy = '';
      let bhyd = '';
      if (args.data.baseline && args.data.baseline.hrv && args.data.baseline.hrv.nominal) {
        bhrv = args.data.baseline.hrv.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.heartrate && args.data.baseline.heartrate.nominal) {
        bhr = args.data.baseline.heartrate.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.temperature && args.data.baseline.temperature.nominal) {
        btemp = args.data.baseline.temperature.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.oxygen && args.data.baseline.oxygen.nominal) {
        boxy = args.data.baseline.oxygen.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.hydration && args.data.baseline.hydration.nominal) {
        bhyd = args.data.baseline.hydration.nominal.toFixed(1);
      }

      const thistooltip = new Tooltip({
        width: '400px',
        height: '200px',
        // <img src=${heartrate} style="display: inline-block;" width="30px" height="30px" />
        // ${args.data.bloodpressure ? args.data.bloodpressure.reading : ''}<sub class="supsm">sys/dia</sub>${bpflag}
        content: `<h1 style="text-align: center;">${args.data.name ? args.data.name.toUpperCase() : ''}: BIOMETRICS</h1><table class="biotable"><tbody><tr><th colspan="2">${riskLevel}</th><tr><td class="biometricsgrn"><sup class="supsm">hr</sup>${args.data.heartrate && args.data.heartrate.reading ? args.data.heartrate.reading : ''}<sub class="supsm">bpm</sub>${hrflag}<sup class="supsm">(${bhr})</sup></td><td class="biometricsltgrn">
      <sup class="supsm">hrv</sup>${args.data.hrv && args.data.hrv.reading ? args.data.hrv.reading : ''}<sub class="supsm">ms</sub>${hrvflag}<sup class="supsm">(${bhrv})</sup></td></tr><tr><td class="biometricsorn"><sub class="supsm">O<sup  class="supsm">2</sup></sub>${args.data.oxygen && args.data.oxygen.reading ? args.data.oxygen.reading : ''}<sub class="supsm">%</sub>${oflag}<sup class="supsm">(${boxy})</sup></td><td class="biometricsylw"><sup class="supsm">temp</sup>${args.data.temperature && args.data.temperature.reading ? args.data.temperature.reading : ''}<sub class="supsm">°F</sub>${tflag}<sup class="supsm">(${btemp})</sup></td></tr><tr><td class="biometricsblue"><sup class="supsm">hyd</sup>${args.data.hydration && args.data.hydration.reading ? args.data.hydration.reading : ''}<sub class="supsm">%</sub>${hflag}<sup class="supsm">(${bhyd})</sup></td><td class="biometricscyn"></td></tr></tbody></table>`,
      });
      thistooltip.appendTo(args.cell);
    }
    /*
      switch (args.column.index) {
        case 1:
          args.cell.classList.add('rowcellgrn');
          break;
        case 2:
          args.cell.classList.add('rowcellgrn');
          break;
        case 3:
          if (temp >= 101) {
            // args.cell.classList.add('below-30');
            args.cell.classList.add('rowcellgrn');
          } else if (temp > 99 && temp < 101) {
            // args.cell.classList.add('below-80');
            args.cell.classList.add('rowcellorn');
          }
          break;
        case 6:
          if (hydration <= 30) {
            args.cell.classList.add('rowcellred');
            // args.cell.classList.add('below-30');
          } else if (hydration > 30 && hydration < 70) {
            // args.cell.classList.add('below-80');
            args.cell.classList.add('rowcellylw');
          } else {
            // args.cell.classList.add('above-80');
            args.cell.classList.add('rowcellgrn');
          }
          break;
        default:
          args.cell.classList.add('rowcellgrn');
          break;
      }
      */
  };
  function recordingDevice(e) {
    if (e.target.itemData.value === 'na') {
      return;
    }
    setSelectedAudioOption(e.target.itemData.value);

    if (!associate || associateid.length === 0 || associateid === 'add_associate') {
      DialogUtility.alert('No associate selected, or invalid state');
      return;
    }
    const b = { device: associate.device, name: associate.name };
    if (!confirm(`Send recording ${e.target.itemData.text} to ${b.name}?`)) {
      return;
    }
    const message = `"audio": "${e.target.itemData.value}"`;
    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        DialogUtility.alert('audio request sent');
        setSelectedAudioOption('na');
      })
      .catch((error) => {
        console.error(error);
      });
  }
  const smsDevice = (e) => {
    if (!e) {
      return;
    }
    if (!associate || associateid.length === 0) {
      DialogUtility.alert('Please select an Associate!');
      return;
    }
    const b = { device: associate.device, name: associate.name };
    const cmd = e.target.itemData.value;
    setSelectedOption(cmd);
    let message = '';
    if (cmd == 'na') {
      DialogUtility.alert('No command supplied');
      return;
    }
    if (b.device == '') {
      DialogUtility.alert('No device selected!');
      return;
    }
    if (cmd === 'reset') {
      message = prompt(`Restart device ${b.device} (${b.name}) or put device to sleep?`, 'restart');
      if (!message || message.length === 0) {
        return;
      }
      if (message.toLocaleLowerCase() === 'restart') {
        message = '"reset":"restart"';
      } else if (message.toLocaleLowerCase() === 'sleep') {
        message = '"reset":"sleep"';
      } else {
        return;
      }
    } else if (cmd === 'fota') {
      if (!confirm(`Send a FOTA request to ${b.name}`)) {
        return;
      }
      message = '"fota":"ind"';
    } else if (cmd === 'locate') {
      message = '"locate":"query"';
      if (!confirm(`Send a LOCATE request to ${b.name}`)) {
        return;
      }
    } else if (cmd === 'rehome') {
      message = prompt(`ReHome device ${b.device} (${b.name}) production, staging or development?`, 'production');
      if (!message || message.length === 0) {
        return;
      }
      switch (message.toLocaleLowerCase()) {
        case 'production':
          message = '"srvr":{"url":"biometric.zackat.com", "port": "10900"}';
          break;
        case 'staging':
          message = '"srvr":{"url":"biometric.zackatlabs.com", "port": "10900"}';
          break;
        case 'development':
          message = '"srvr":{"url":"biometric.zackat.com", "port": "10900"}';
          break;
        default:
          message = `"srvr":{"url":"${message}", "port": "10900"}`;
          break;
      }
    } else {
      message = prompt(`What SMS would you like to send to ${b.device} (${b.name})?`, '');
    }
    if (!message || message.length === 0) {
      return;
    }
    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        DialogUtility.alert(`${cmd} request sent`);
        setSelectedOption('na');
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const actionComplete = (args) => {
    const org = JSON.parse(localStorage.getItem('organization'));
    /** Set initial Focus */
    setEvents(true);

    if (args.requestType === 'beginEdit') {
      // args.form.elements.namedItem('name').focus();
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog && args.rowData && args.rowData.name) {
        dialog.header = `Details of ${args.rowData.name}`;
      }
    } else if (args.requestType === 'add') {
      args.form.elements.namedItem('name').focus();
    } else if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args.data && args.data.name.length > 0) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        if (!args.data.organizationid || args.data.organizationid.length === 0) {
          args.data.organizationid = org.id;
          args.data.organization = org.name;
        }
        fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              DialogUtility.alert(responseJson.response);
              args.cancel = true;
            }
          })
          .catch((error) => {
            DialogUtility.alert('An error has occured during Insert!');
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        orgData.forEach((element) => {
          if (element.id === args.data.organizationid) {
            args.data.organizationid = element.id;
            args.data.organization = element.value;
          }
        });
        fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
          })
          .catch((error) => {
            DialogUtility.alert('An error has occured during Update!');
          });
      }
    } else if (args.requestType === 'delete') {
      let entry = ' this entry?';
      if (args.data.length > 1) {
        entry = ' these entries?';
      }
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
          })
          .catch((error) => {
            DialogUtility.alert('An error has occured during Delete!');
          });
      }
    }
  };
  function setUserPreferences(pref, val) {
    if (!data.user.preferences) {
      data.user.preferences = {};
    }
    if (!data.user.preferences.associate) {
      data.user.preferences.associate = {};
    }
    if (pref === 'group') {
      data.user.preferences.associate = { group: val, biometrics: data.user.preferences.associate.biometrics, sort: data.user.preferences.associate.sort, limit: Number(limit) };
    } else if (pref === 'biometrics') {
      data.user.preferences.associate = { group: data.user.preferences.associate.group, biometrics: val, sort: data.user.preferences.associate.sort, limit: Number(limit) };
    } else if (pref === 'sort') {
      data.user.preferences.associate = { group: data.user.preferences.associate.group, biometrics: data.user.preferences.associate.biometrics, sort: val, limit: Number(limit) };
    } else if (pref === 'limit') {
      data.user.preferences.associate = { group: data.user.preferences.associate.group, biometrics: data.user.preferences.associate.biometrics, sort: data.user.preferences.associate.sort, limit: Number(val) };
    }
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    if (data.user.lastLogin && data.user.lastLogin === '') {
      data.user.lastLogin = '1970-01-01T00:00:00.000Z';
    }

    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert(responseJson.response);
        }
      })
      .catch((error) => {
        navigate('/login');
      });
  }
  function handleChangeLimit(e) {
    setLimit(e.target.value);
    setUserPreferences('limit', e.target.value);
  }
  function changeColDisplay() {
    setColDisplay(!colDisplay);
    setUserPreferences('biometrics', !colDisplay);
  }
  const actionBegin = (args) => {
    if (args.requestType === 'ungrouping' || args.requestType === 'grouping') {
      const index = groups.indexOf(args.columnName);
      if (index > -1 && args.requestType === 'ungrouping') { // only splice array when item is found
        groups.splice(index, 1); // 2nd parameter means remove one item only
      } else if (index === -1 && args.requestType === 'grouping') { // only splice array when item is found
        groups.push(args.columnName); // 2nd parameter means remove one item only
      }
      setUserPreferences('group', groups);
    } else if (args.requestType === 'sorting') {
      setUserPreferences('sort', [{ field: args.columnName, direction: args.direction }]);
    }
    /*
    if (!grid || !grid.columns) {
      return;
    }

    const cols = grid.columns;
    for (const col of cols) {
      if (col.headerText === 'Image' || col.headerText === 'Events' || col.headerText === 'Supervisor') {
        col.allowEditing = false;
      }
      if (col.headerText == 'Risk' || col.headerText == 'Environment') {
        col.visible = true;
      }
      if (args.requestType == 'add' && col.headerText === 'ID') {
        col.visible = false;
      }
      if (args.requestType == 'add' && col.headerText === 'Organization') {
        // col.visible = false;
      }
      if (args.requestType == 'filter' && (col.headerText == 'Image' || col.headerText == 'Name' || col.headerText == 'Device'
        || col.headerText == 'Organization' || col.headerText == 'Job Task')) {
        col.visible = true;
      } else if (args.requestType == 'filter' && (col.headerText == 'Temperature' || col.headerText == 'Bloodpressure'
        || col.headerText == 'Oxygen' || col.headerText == 'Heartrate' || col.headerText == 'HR Variability' || col.headerText == 'Hydration' || col.headerText == 'Fatigue'
        || col.headerText == 'Activity')) {
        col.visible = colDisplay;
      } else if (args.requestType == 'beginEdit') {
        setEvents(false);
        if (col.headerText == 'Risk' || col.headerText == 'Environment' || col.headerText == 'Image' || col.headerText == 'Man Down' || col.headerText == 'Temperature' || col.headerText == 'Bloodpressure' || col.headerText == 'Oxygen' || col.headerText == 'Heartrate' || col.headerText == 'Hydration' || col.headerText == 'HR Variability' || col.headerText == 'Fatigue' || col.headerText == 'Activity' || col.headerText == 'ID') {
          col.visible = false;
        } else {
          col.visible = true;
        }
      } else if (args.requestType == 'add') {
        if (col.headerText == 'Risk' || col.headerText == 'Environment' || col.headerText == 'Man Down' || col.headerText == 'Temperature' || col.headerText == 'Bloodpressure' || col.headerText == 'Oxygen' || col.headerText == 'Heartrate' || col.headerText == 'HR Variability' || col.headerText == 'Hydration' || col.headerText == 'Fatigue' || col.headerText == 'Activity') {
          col.visible = false;
        } else {
          col.visible = true;
        }
      } else if (col.headerText == 'Image' || col.headerText == 'Name' || col.headerText == 'Device' || col.headerText == 'Temperature' || col.headerText == 'Bloodpressure'
        || col.headerText == 'Oxygen' || col.headerText == 'Heartrate' || col.headerText == 'HR Variability' || col.headerText == 'Hydration' || col.headerText == 'Fatigue'
        || col.headerText == 'Activity' || col.headerText == 'Man Down' || col.headerText == 'Organization' || col.headerText == 'Job Task' || col.headerText == 'Risk' || col.headerText == 'Environment') {
        col.visible = true;
      } else {
        col.visible = false;
      }
      if (col.headerText === 'Language') {
        col.visible = true;
      }
      if (col.headerText === 'Device') {
        if ((args.requestType === 'beginEdit' || args.requestType === 'add') && args.type === 'actionBegin') {
          col.visible = true;
        } else {
          col.visible = false;
        }
      }
      if (col.headerText === 'Job Task') {
        if ((args.requestType === 'beginEdit' || args.requestType === 'add') && args.type === 'actionBegin') {
          col.visible = true;
        } else {
          col.visible = false;
        }
      }
    }
*/
  };
  function completeUpload(args) {
    DialogUtility.alert('Your upload is complete!');
    setReload(!reload);
  }
  useEffect(() => {
    if (currentAssociate && currentAssociate.length > 0) {
      setName(currentAssociate);
    }
  }, [currentAssociate]);

  useEffect(() => {
    if (grid) {
      setEvents(false);
      const selectedRecords = grid.getSelectedRecords();
      if (selectedRecords && selectedRecords.length === 1) {
        const row = grid.getSelectedRowIndexes();
        if (amapActive) {
          grid.selectRow(row[0], 1);
          setEvents(true);
          // setDetails(!enableDetails);
        } else if (selectedRecords.length > 0) {
          setAssociateId(selectedRecords[0]._id);
          setPatientId(selectedRecords[0]._id);
          setEmail(selectedRecords[0].email);
          setRiskColor('e-outline');
          setEnvColor('e-outline');
          if (selectedRecords[0].risk < 0) {
            setRiskColor('e-outline e-info');
            setHypoColor('cyan');
            setBaseColor('transparent');
            setModerateColor('transparent');
            setElevatedColor('transparent');
            setSevereColor('transparent');
          } else if (selectedRecords[0].risk === '' || selectedRecords[0].risk < 25) {
            setRiskColor('e-outline e-success');
            setHypoColor('transparent');
            setBaseColor('cyan');
            setModerateColor('transparent');
            setElevatedColor('transparent');
            setSevereColor('transparent');
          } else if (selectedRecords[0].risk < 50) {
            setRiskColor('e-outline e-info');
            setHypoColor('transparent');
            setBaseColor('transparent');
            setModerateColor('cyan');
            setElevatedColor('transparent');
            setSevereColor('transparent');
          } else if (selectedRecords[0].risk < 80) {
            setRiskColor('e-outline e-warning');
            setHypoColor('transparent');
            setBaseColor('transparent');
            setModerateColor('transparent');
            setElevatedColor('cyan');
            setSevereColor('transparent');
          } else if (selectedRecords[0].risk && selectedRecords[0].risk.length > 0) {
            setRiskColor('e-outline e-error');
            setHypoColor('transparent');
            setBaseColor('transparent');
            setModerateColor('transparent');
            setElevatedColor('transparent');
            setSevereColor('cyan');
          }
        } else {
          setRiskColor('e-outline');
          setAssociateId('');
          setPatientId('');
          setEvents(true);
          setDetails(true);
        }
      } else {
        setAssociateId('');
        setPatientId('');
        setEvents(true);
        setDetails(true);
      }
    }
  }, [dataChanged, amapActive]);

  function rowClicked() {
    // setAssociateId('');
    setPatientId('');
    setDataChanged(!dataChanged);
  }
  let uploadObj;
  const path = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/associatesremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/associatesupload`,
  };
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };
  function onFileUpload(args) {
    // add addition data as key-value pair.
    const result = orgData.find(({ id }) => id === selUploadOrganization);
    if (!result || !result.value || result.value === '') {
      DialogUtility.alert('Invalid Organization');
      args.cancel = true;
      return;
    }
    if (!confirm(`Upload to ${result.value}`)) {
      args.cancel = true;
      return;
    }
    args.customFormData = [{ organizationid: selUploadOrganization }];
  }
  const FilterOptions = {
    type: 'FilterBar',
    showFilterBarStatus: true,
    mode: 'Immediate',
  };
  /*
  const doubleClickHandler = (args) => {
    // grid.preventClick = true;
    navigate(`../basic?id=${args.rowData._id}&lat=${args.rowData.latlng.latitude}&lng=${args.rowData.latlng.longitude}`);
  };
  */
  const clickHandler = (args) => {
    if (grid && args.item.properties.text === 'Location') {
      const selectedRecords = grid.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select an associate');
      } else if (selectedRecords && selectedRecords.length === 1) {
        navigate(`../basic?id=${selectedRecords[0]._id}&lat=${selLat}&lng=${selLng}&name=${selectedRecords[0].name}&tabNo=1`);
      } else {
        DialogUtility.alert('Please select only one associate');
      }
    } else if (grid && args.item.properties.text === 'Events') {
      const selectedRecords = grid.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select an associate');
      } else if (selectedRecords && selectedRecords.length === 1) {
        navigate(`../events?id=${selectedRecords[0]._id}&lat=${selLat}&lng=${selLng}&name=${selectedRecords[0].name}`);
      } else {
        DialogUtility.alert('Please select only one associate');
      }
    } else if (grid && args.item.properties.text === 'Invite') {
      const selectedRecords = grid.getSelectedRecords();
      const recipient = prompt('Please enter the email address of the Associate that you would like to receive the invitation!', selEmail);
      if (recipient) {
        fetch(`${REACT_APP_API_ENDPOINT}/invite?associateid=${selectedRecords[0]._id}&recipient=${recipient}&email=${usr.email}`, {
          method: 'GET',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
          },
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              DialogUtility.alert(responseJson.response);
              args.cancel = true;
            }
          })
          .catch((error) => {
            DialogUtility.alert('An error has occured during Invitation request!');
            args.cancel = true;
          });
      }
    } else if (grid && args.item.properties.text === 'AI') {
      setAIType('Predictive Analysis');
      handleClick('userFaq');
    } else if (grid && args.item.properties.text === 'Alerts') {
      const selectedRecords = grid.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select an associate');
      } else if (selectedRecords && selectedRecords.length === 1) {
        const updateAssociate = async () => {
          selectedRecords[0].activity.alert = '';
          selectedRecords[0].oxygen.alert = '';
          selectedRecords[0].heartrate.alert = '';
          selectedRecords[0].hrv.alert = '';
          selectedRecords[0].temperature.alert = '';
          selectedRecords[0].hydration.alert = '';
          selectedRecords[0].bloodpressure.alert = '';
          const newData = selectedRecords[0];
          axios.defaults.headers.common.Authorization = `JWTToken ${usr.token}`;
          axios.put(
            `${REACT_APP_API_ENDPOINT}/associates`,
            newData,
          ).then((response) => {
            // Handle the response
            // window.location.reload();
            setReload(!reload);
            // data.associates = selectedRecords;
          })
            .catch((error) => {
              // Handle errors
            });
        };
        updateAssociate();
      } else {
        DialogUtility.alert('Please select only one associate');
      }
    } else if (grid && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_Associates_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.pdfExport(properties);
    } else if (grid && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_Associates_${new Date().toISOString()}.xlsx`,
      };
      grid.excelExport(properties);
    } else if (grid && args.item.properties.text === 'Add') {
      setRisk('');
      setEnvironment('');
      setName('');
      setDevice('');
      setMobile('');
      setEmail('');
      setReportsTo('');
      setAddress('');
      setAddress1('');
      setCity('');
      setState('');
      setZip('');
      setDob('');
      setSMSOptin(false);
      setEmailOptin(false);
      setGender('');
      setEmployeeImage('https://monaco.zackat.com/blank.png');
      setLanguage(null);
      setEngineering(false);
      setOrganization(null);
      setAssociate(null);
      setAssociateId('add_associate');
      setPatientId('');
    }
  };
  if (activeMenu === false) {
    myScreenSize = 'auto';
  } else {
    const s = (screenSize - 450).toString();
    myScreenSize = `${s}px`;
  }
  /*
  if (!selectedOrg || !selectedOrg.id) {
    return <p>-- Please select and organization -- </p>;
  }
  */
  if (loading) {
    setTimeout(() => {
      const e = document.getElementById('loadingdata');
      if (e) {
        e.innerText += '.';
      }
    }, 1000);
    return <p id="loadingdata">Loading </p>;
  }
  if (data.role && data.role.associates) {
    if (!data.role.associates.permissions.includes('Read')) {
      return <p>Not authorized...</p>;
    }
  }
  const acrdnheader1 = () => (<div>Vitals</div>);
  const acrdnContent1 = () => (<div>Temperature: {associate.temperature.reading}°F</div>);
  const editOptions = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Dialog',
  };
  data.organization.forEach((org) => {
    const result = orgData.find(({ id }) => id === org._id);
    if (!result || result.value !== '') {
      orgData.push({ id: org._id, value: org.title });
    }
  });
  if (data.recordings) {
    data.recordings.forEach((rec) => {
      const result = langData.find(({ id }) => id === rec.language);
      audioData.push({ value: rec._id, text: `${rec.name} (${result.value})` });
    });
  }

  const organizations = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(data.organization),
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };

  const valuerules = { required: true };
  const uploaderTemplate = (d) => {
    const cl = `icon template-icons sf-icon-${d.type}`;
    return (
      <div>
        <span className="wrapper">
          <span className={cl} />
          <span className="name file-name">{d.name}</span>
        </span>
        <span className="file-size-td file-size">{d.size} bytes</span>
        <span className="e-icons e-file-remove-btn" title="Remove" /> <br />
        <progress id="progressBar" className="progressbar" value="0" max="100" />
        <span className="percent-td percent" />
      </div>
    );
  };
  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div">
      <div className="flex">
        <Link
          className="my-link"
          to="https://scribehow.com/viewer/Associate_Page_and_view_Event_Charts_Logs_and_more__hQvYnpJFRzqIpuLbFmD6YQ"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Operations" title="Individual Associate" />
      </div>
      <div
        style={{
          backgroundColor: currentThemeColor,
          textAlign: 'left',
          width: '100%',
        }}
      />
      <div>
        {!loading && (
        <ToolbarComponent id="toolbar" onClick={onToolbarChange}>
          <ItemsDirective>
            {boss && <ItemDirective text="Raw Events" prefixIcon="e-justify" disabled={!boss} />}
            <ItemDirective type="Separator" />
            <ItemDirective template={actionComponent} disabled={associateid === ''} />
            <ItemDirective type="Separator" />
            <ItemDirective template={audioComponent} disabled={associateid === ''} />
            <ItemDirective type="Separator" />
            <ItemDirective text="Search" template={searchComponent} style={{ float: 'right !important' }} />
            <ItemDirective type="Separator" />

          </ItemsDirective>
        </ToolbarComponent>
        )}
        <div className="flex" height="100px">
          <GridComponent
            ref={(scope) => { grid = scope; }}
            id="assocGrid"
            width="100%"
            dataSource={data.associates}
            allowPaging
            allowSorting
            allowFiltering={false}
            filterSettings={FilterOptions}
            allowResizing
            pageSettings={{ pageSize: 1, pageCount: 1 }}
            editSettings={editOptions}
            toolbar={toolbarOptions}
            toolbarClick={clickHandler}
            sortSettings={sortOptions}
            actionComplete={actionComplete}
            actionBegin={actionBegin}
            allowTextWrap
            allowPdfExport
            allowExcelExport
            allowGrouping
            enableAdaptiveUI={isMobile}
            rowRenderingMode={zRenderMode}
            groupSettings={groupOptions}
            recordClick={rowClicked}
          >
            <ColumnsDirective>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              {associateGrid.map((item, index) => <ColumnDirective key={index} visible={colDisplay} {...item} />)}
              <ColumnDirective
                field="organizationid"
                headerText="Organization"
                width="150"
                textAlign="Left"
                editType="dropdownedit"
                validationRules={valuerules}
                visible
                foreignKeyField="_id"
                foreignKeyValue="title"
                dataSource={organizations.params.dataSource}
              />
            </ColumnsDirective>
            <Inject services={[Page, Edit, Toolbar, Filter, Sort, Resize, PdfExport, ExcelExport, ForeignKey, Group, LazyLoadGroup, VirtualScroll]} />
          </GridComponent>
        </div>
        {associateid !== '' && crudCreate
            && (
              <div className="control-section accordion-control-section" style={{ width: '100%' }}>
                <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
                  <AccordionComponent>
                    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div">
                      <div className="e-input-group">
                        <div className="mt-4" style={{ width: '100%' }}>  Edit Associate </div>
                      </div>
                      <form>
                        <table className="biotable" style={{ width: '100%' }}>
                          <tbody>
                            <tr>
                              <th style={{ backgroundColor: hypoColor }}><font color="blue">HYPO</font></th>
                              <th style={{ backgroundColor: baseColor }}><font color="green">BASELINE</font></th>
                              <th style={{ backgroundColor: moderateColor }}><font color="yellow">MODERATE</font></th>
                              <th style={{ backgroundColor: elevatedColor }}><font color="orange">ELEVATED</font></th>
                              <th style={{ backgroundColor: severeColor }}><font color="red">SEVERE</font></th>
                            </tr>
                          </tbody>
                        </table>
                        {associateid !== 'add_associate' && (
                          <div className="control-section accordion-control-section">
                            <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
                              <AccordionComponent multiple>
                                <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                                  <div className="e-input-group">
                                    <div className="mt-4"> Vitals </div>
                                  </div>
                                  <div className="mt-2 e-input-group">
                                    <TextBoxComponent multiline htmlAttributes={multilineAttributes} value={selVitals} title="vital readings" disabled cssClass={riskColor} readOnly floatLabelType="Never" onChange={() => { }} />
                                  </div>
                                </div>
                              </AccordionComponent>
                            </div>
                          </div>
                        )}
                        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                          <div className="e-input-group">
                            <TextBoxComponent placeholder="Risk" value={selRisk} title="Calculated based on baseline, and vitals readings" disabled cssClass={riskColor} readOnly floatLabelType="Auto" onChange={() => { }} />
                            <TextBoxComponent placeholder="Environment" title="Calculated based on climate conditions" value={selEnvironment} disabled cssClass={envColor} readOnly floatLabelType="Auto" onChange={() => { }} />
                          </div>
                        </div>
                        {associateid !== 'add_associate' && (
                          <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                            <div className="e-input-group">
                              <img src={selEmployeeImage} className="w-10 h-10" value={selName} id={associateid} />
                              <input type="file" name="userfile" id={associateid} onChange={handleChange} />
                            </div>
                          </div>
                        )}
                        {/* <font color="black"><input type="submit" name="remove" id={associate._id} value="&#x007F;" onClick={removePhoto} /></font> */}
                        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                          <div className="e-input-group">
                            <TextBoxComponent placeholder="Enter Name" value={selName} required showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setName(v.value); }} />
                            <TextBoxComponent placeholder="Reports To" title="Controlled via Manager tab" disabled value={selReportsTo} cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setReportsTo(v.value); }} />
                          </div>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                          <div className="e-input-group">
                            <TextBoxComponent placeholder="Enter Address" value={selAddress} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAddress(v.value); }} />
                          </div>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                          <div className="e-input-group">
                            <TextBoxComponent placeholder="Enter Address cont." value={selAddress1} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAddress1(v.value); }} />
                          </div>
                        </div>

                        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                          <div className="e-input-group">
                            <TextBoxComponent placeholder="Enter City" value={selCity} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setCity(v.value); }} />
                          </div>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                          <div className="e-input-group">
                            <TextBoxComponent placeholder="Enter State" value={selState} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setState(v.value); }} />
                          </div>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                          <div className="e-input-group">
                            <TextBoxComponent placeholder="Enter Zip" value={selZip} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setZip(v.value); }} />
                          </div>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                          <div className="e-input-group">
                            <TextBoxComponent placeholder="Mobile" value={selMobile} type="text" showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setMobile(v.value); }} />
                            <TextBoxComponent placeholder="Email Address" value={selEmail} type="email" showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setEmail(v.value); }} />
                          </div>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                          <div className="e-input-group">
                            <TextBoxComponent placeholder="Device" width={250} title="SIM Device Identification" showClearButton value={selDevice} type="text" cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setDevice(v.value); }} />
                          </div>
                        </div>

                        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                          <div className="e-input-group">
                            <CheckBoxComponent label="SMS OptIn" title="Controlled via mobile App" disabled checked={smsOptin} />
                            <CheckBoxComponent label="Email OptIn" title="Controlled via mobile App" disabled checked={emailOptin} />
                            {boss && <CheckBoxComponent label="Engineering Use Only" checked={selEngineering} change={(v) => { setEngineering(v.checked); }} />}

                          </div>
                        </div>
                        <div className="row custom-margin">
                          <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
                            <div className="e-input-group">
                              <DatePickerComponent id="dob" cssClass="e-outline" floatLabelType="Auto" onChange={setDateOfBirth} placeholder="Date of Birth" value={selDob} />
                              <TextBoxComponent placeholder="Age" width={100} title="Calculated from Date of Birth" value={selAge} type="text" disabled cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAge(v.value); }} />
                              <div className="row">
                                <RadioButtonComponent label="Male" name="gender" value="male" checked={gender === 'male'} onChange={(v) => { setGender(v.value); }} />
                              </div>
                              <div className="row">
                                <RadioButtonComponent label="Female" name="gender" value="female" checked={gender === 'female'} onChange={(v) => { setGender(v.value); }} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row custom-margin">
                          <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
                            <div className="e-input-group">
                              <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selOrganization} onChange={(v) => { setOrganization(v.value); }} />
                              <DropDownListComponent id="ddllanguage" cssClass="e-outline" dataSource={langParams.params.dataSource} fields={langParams.params.fields} placeholder="Select Language" value={selLanguage} onChange={(v) => { setLanguage(v.value); }} />
                            </div>
                          </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-lg-6 col-md-6">
                          <ButtonComponent cssClass="e-outline e-warning" onClick={cancelProfile}>Cancel</ButtonComponent>
                          <ButtonComponent style={{ float: 'right' }} cssClass="e-outline e-info" onClick={saveProfile}>Save</ButtonComponent>
                        </div>
                      </form>
                    </div>
                  </AccordionComponent>
                </div>
              </div>
            )}
      </div>
      {associate && associateid !== '' && (
        <div className="control-section accordion-control-section" style={{ width: '100%' }}>
          <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
            <AccordionComponent>
              <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                <div className="e-input-group">
                  <div className="mt-4"> Events </div>
                </div>
                <div>
                  <Events props={associate} />
                </div>
              </div>
            </AccordionComponent>
          </div>
        </div>
      )}
      {associate && associateid !== '' && (
        <div className="control-section accordion-control-section">
          <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
            <AccordionComponent expanded={expandCharts}>
              <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                <div className="e-input-group">
                  <div className="mt-4" style={{ width: '100%' }}>  Charts </div>
                </div>
                <div style={{ width: '100%' }}>
                  <Heartbeat props={associate} />
                </div>
              </div>
            </AccordionComponent>
          </div>
        </div>
      )}
      {associate && associateid !== '' && (
        <div className="control-section accordion-control-section">
          <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
            <AccordionComponent>
              <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                <div className="e-input-group">
                  <div className="mt-4" style={{ width: '100%' }}>  Location </div>
                </div>
                <div style={{ width: '100%' }}>
                  <GMap props={associate} />
                </div>
              </div>
            </AccordionComponent>
          </div>
        </div>
      )}
      {boss && associate && associateid !== '' && (
      <div className="control-section accordion-control-section" style={{ width: '100%' }}>
        <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
          <AccordionComponent>
            <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
              <div className="e-input-group">
                <div className="mt-4"> Dev Logs </div>
              </div>
              <div>
                <DevLog props={associate} />
              </div>
            </div>
          </AccordionComponent>
        </div>
        {isClicked.userFaq && (<UserFAQ dt="Predictive Analysis" />)}
      </div>
      )}

    </div>
  );
};
export default AssociatePage;
